import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";
import { mergeLocaleCatalogSlices } from "./merge-message-tree";
import { redblueSchemeDetailPageMessages } from "./pages-scheme-detail";
import { redblueSchemeIntelligencePageMessages } from "./pages-scheme-intelligence";
import { redblueSchemeListPageMessages } from "./pages-scheme-list";

export const redblueSchemePageMessages: Record<AppLocale, MessageTree> = mergeLocaleCatalogSlices([
  redblueSchemeListPageMessages,
  redblueSchemeDetailPageMessages,
  redblueSchemeIntelligencePageMessages,
]);
